import { render } from "./Field-l-fe.vue?vue&type=template&id=487094f6"
import script from "./Field-l-fe.vue?vue&type=script&lang=js"
export * from "./Field-l-fe.vue?vue&type=script&lang=js"

import "./Field-l-fe.vue?vue&type=style&index=0&id=487094f6&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__